export const PERMISSION_TYPE = {
  READ_CAMPAIGNS: "store:read_campaigns",
  READ_OVERVIEW: "store:read_overview",
  MANAGE_ORDERS: "store:manage_orders",
  MANAGE_POINTS: "store:manage_points",
  REDEEM_POINTS: "store:redeem_points",
  TRANSFER_POINTS: "store:use_points", // reminder: remove redundancy after
  USE_POINTS: "store:use_points",
  BUY_POINTS: "store:buy_points",
  MANAGE_SUPPORT: "store:manage_support", // view support tab
  MANAGE_STORE: "store:manage_store", // activate/deactivate store
  DASHBOARD_ACCESS: "store:access", // store dashboard access
  STORE_FEATURE_FLAG: "store:feature_flag",
};
